<template>
  <div>
    <b-container>

      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div class="d-flex align-items-start">
          <div>
            <back-arrow />
          </div>
          <div>
            <h1 class="page-title">Chirurgies pour hospitalisation</h1>
            <h2 class="page-subtitle">Total : {{ surgeries.length }}</h2>
          </div>
        </div>
        <b-button variant="primary" @click="clickOnCreateBtn">
          <plus-icon size="18" class="mr-1" /> Ajouter chirurgie
        </b-button>
      </div>

      <b-card
        v-if="surgeries.length === 0"
        class="mt-4"
      >
        Aucune chirurgie n'est renseignée pour cette hospitalisation
      </b-card>

      <b-card
        class="mt-2 mb-4 shadow-sm"
        v-for="surgery in surgeries" :key="surgery.id">
        <div class="d-flex justify-content-between align-items-start">
          <div>
            <h4 class="card-title">{{ surgery.name }}</h4>
            <h6 class="card-subtitle text-muted mb-2">{{surgery.startDateToString}} - {{ surgery.surgeryStatus.name }}</h6>
          </div>
          <div>
            <card-actions
              :itemId="surgery.id"
              @clickOnEditBtn="clickOnEditBtn"
              @clickOnDeleteBtn="clickOnDeleteBtn"
            ></card-actions>
          </div>
        </div>
        <div class="multiline" v-if="surgery.description">
          {{surgery.description}}
        </div>
      </b-card>
    </b-container>

    <!-- Modal Delete -->
    <surgery-delete-modal :selected="ui.selected" @didDeleteSurgery="didDeleteSurgery()"></surgery-delete-modal>
  </div>

</template>

<script>

import api from "../../services/api";
import BackArrow from "../../components/BackArrow";
import CardActions from "../../components/CardActions";
import SurgeryDeleteModal from "./SurgeryDeleteModal";

export default {

  name: 'SurgeryForHospitalization',

  components: {
    BackArrow,
    CardActions,
    SurgeryDeleteModal
  },

  data() {
    return {
      hospitalizationId: this.$route.params.hospitalizationId,
      surgeries: [],
      ui: {
        selected: null
      }
    }
  },

  mounted() {
    this.fetchSurgeries()
  },

  methods: {

    fetchSurgeries(){
      api
        .get(`/surgery/getSurgeriesByHospitalization?hospitalizationId=${this.hospitalizationId}`)
        .then(response => {
          this.surgeries = response.data
        })
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'SurgeryCreate',
        params: {
          hospitalizationId: this.hospitalizationId
        }
      })
    },

    clickOnEditBtn(id) {
      this.$router.push({
        name: 'SurgeryEdit',
        params: {
          surgeryId: id,
          hospitalizationId: this.hospitalizationId
        }
      })
    },

    clickOnDeleteBtn(id) {
      this.ui.selected = this.surgeries.find((surgery) => surgery.id === id)
      this.$bvModal.show('surgery-delete-modal')
    },

    didDeleteSurgery() {
      this.ui.selected = null
      this.fetchSurgeries()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/surgery/SurgeryForHospitalization.vue